import Image from "next/legacy/image";

import { logClickHubLandingButton } from "@/businessLogics/_common/logging";
import { useCustomRemoteConfig } from "@/hooks/hackle";
import { CustomLink } from "../CustomLink/template";

import * as D from "./data";
import * as S from "./style";
import { useAtom } from "jotai";
import { alimModalCourseAtom } from "@/states/notification";

export default function Template({ userInfo }) {
  const coursesInfo = useCustomRemoteConfig("swc_herb_course_data");
  const [, setAlimModalCourse] = useAtom(alimModalCourseAtom);
  function handleClickCardButton(title: string) {
    switch (title) {
      case "UIUX 디자이너 코스":
        setAlimModalCourse("designer");
        break;
      case "PM 코스":
        window.open("https://hanghae99.spartacodingclub.kr/pm", "_blank");
      // setAlimModalCourse("pm");
    }
    const courseInfoArray = title.split(" ");
    const courseTitle = courseInfoArray[0];
    const courseRound =
      courseInfoArray.at(-1) === "코스" ? "1기" : courseInfoArray.at(-1);
    logClickHubLandingButton(courseTitle, courseRound);
  }

  return (
    <S.Wrapper id={"course-div"}>
      <S.ContentWrapper>
        <S.Title>
          <D.Title></D.Title>
        </S.Title>
        <S.CardsWrapper>
          {D.coursesInfo(coursesInfo).map(
            ({ title, subTitle, desc, icon, url, button, course }) => (
              <CustomLink
                key={title}
                url={url}
                userInfo={userInfo}
                course={course}
              >
                <S.Card>
                  <S.CardHeader>
                    <S.CardIcon>
                      <Image
                        layout="fill"
                        objectFit="cover"
                        objectPosition="center"
                        src={icon}
                        alt={title}
                      />
                    </S.CardIcon>
                    <S.CardTitleWrapper>
                      <S.CardTitle>{title}</S.CardTitle>
                      <S.CardDiscount>{subTitle}</S.CardDiscount>
                    </S.CardTitleWrapper>
                  </S.CardHeader>
                  <S.CardBody>{desc}</S.CardBody>
                  <S.CardButton onClick={() => handleClickCardButton(title)}>
                    {button}
                  </S.CardButton>
                </S.Card>
              </CustomLink>
            )
          )}
        </S.CardsWrapper>
      </S.ContentWrapper>
    </S.Wrapper>
  );
}
